import createFetchClient from 'openapi-fetch';
import { BaseUrl } from '~/types/baseUrl';
import createClient from 'openapi-react-query';
import { paths } from './openapi';

const baseUrl: BaseUrl = {
  production: 'https://platform.versori.com/api/organisations/v1',
  staging: 'https://platform-staging.versori.com/api/organisations/v1',
  development: 'http://localhost:8081/v1',
};

export const organisationsApiFetchClient = createFetchClient<paths>({
  baseUrl: import.meta.env.DEV ? baseUrl.development : import.meta.env.VITE_STAGING ? baseUrl.staging : baseUrl.production,
  credentials: 'include',
  mode: 'cors',
  headers: {
    ...(import.meta.env.VITE_API_JWT && {
      'X-Versori-Internal-Token': import.meta.env.VITE_API_JWT,
    }),
  },
});

export const organisationsApi = createClient(organisationsApiFetchClient);
